import { render, staticRenderFns } from "./sopEdit.vue?vue&type=template&id=3d437408&"
import script from "./sopEdit.vue?vue&type=script&lang=js&"
export * from "./sopEdit.vue?vue&type=script&lang=js&"
import style0 from "./sopEdit.vue?vue&type=style&index=0&id=3d437408&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports